import { Settings, useSaveSettings } from '@ais-ui/websockets';
import { useToast } from '@ais-ui/ui-core';
import { useSettings } from '../Settings/SettingsProvider';

export const useSaveShiplistSettings = () => {
  const { settings } = useSettings();
  const { mutate: mutateSettings } = useSaveSettings();
  const { toast } = useToast();

  const saveShiplistSettings = (
    updatedShiplistsId: string[],
    isCurrentlyApplied: boolean,
    setIsSubmitting?: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    const currentColorState =
      settings['ribbonPlugin.settings']?.ship_color_state;
    let settingsToSave: Settings;

    if (!isCurrentlyApplied && currentColorState !== 'LegendShipList') {
      settingsToSave = {
        ...settings,
        'ribbonPlugin.settings': {
          ...settings['ribbonPlugin.settings'],
          legend_shiplists: updatedShiplistsId,
          ship_color_state: 'LegendShipList',
        },
      };
    } else {
      settingsToSave = {
        ...settings,
        'ribbonPlugin.settings': {
          ...settings['ribbonPlugin.settings'],
          legend_shiplists: updatedShiplistsId,
        },
      };
    }

    mutateSettings(settingsToSave, {
      onSuccess: () => {
        toast({
          className: 'apply-shiplist-success-toast',
          title: 'Success',
          description: `Successfully ${
            isCurrentlyApplied ? 'removed' : 'applied'
          } color by shiplist.`,
        });
        if (setIsSubmitting) {
          setIsSubmitting(false);
        }
      },
      onError: () => {
        toast({
          className: 'apply-shiplist-error-toast',
          title: 'Error',
          description: `Failed to ${
            isCurrentlyApplied ? 'remove' : 'apply'
          } color by shiplist.`,
          variant: 'destructive',
        });
        if (setIsSubmitting) {
          setIsSubmitting(false);
        }
      },
    });
  };

  return { saveShiplistSettings };
};
